import { classed } from "#palette/style";

export const ButtonBase = classed.button`w-full px-6 py-2 text-sm font-medium tracking-wide capitalize transition-colors duration-300 transform rounded-lg focus:outline-none border shadow`;
export const Button = classed(
  ButtonBase,
)`text-brand-900 bg-white border-brand-300 hover:bg-brand-900 hover:text-white`;
export const PrimaryButton = classed(
  ButtonBase,
)`text-white bg-brand-900 hover:bg-brand-700 disabled:bg-brand-900/20 disabled:hover:bg-brand-900/20`;
export const DestructiveButton = classed(
  ButtonBase,
)`text-white bg-status-error-fg hover:bg-status-error-fg/70`;
